<i18n
  src="@/locales/views/agro_exporter/quality_reports/container/list_containers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_reports_container_list_processes_path"
    :params="{
      agro_exporter_id: agro_exporter_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, agro_exporter_process.name]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="containers.length + ' ' + $t('labels.total_number_containers')"
        />
        <span class="space-actions" />
        <badge-default
          :label="total_inspections + ' ' + $t('labels.total_number_inspections')"
        />
      </div>
    </div>

    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.load_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.packing_house") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.total_inspections") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">
                    {{ container.week }}
                  </td>
                  <td class="table-cell-main">
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    {{ container.customer?.name }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.load_date) }}
                  </td>
                  <td class="table-cell">
                    {{ container.packing_house?.name }}
                  </td>
                  <td class="table-cell">
                    {{ container.total_inspections || "" }}
                  </td>
                  <td class="table-cell-action">
                    <button class="link" @click="goToTemplates(container)">
                      <i class="fa-solid fa-eye"></i
                      ><span class="space-icon"></span>
                      {{ $t("labels.show_link") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_reports/container/list_containers.js";
export default {
  name: "AEQualityReportsContainerListContainers",
  props: ["agro_exporter_id", "agro_exporter_process_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      containers: []
    };
  },
  computed: {
    total_inspections: function () {
      return this.containers.reduce(
        (sum, value) => sum + value.total_inspections,
        0
      );
    }
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.containers = response.data;
      this.load_data_general = true;
    },
    goToTemplates: function (container) {
      this.$router.push({
        name: "ae_quality_reports_container_list_templates_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchAgroExporterProcess();
        this.fetchContainers();
      })
    );
  }
};
</script>
